// Generate mock daily operations for a specific date
export const generateMockDailyOperations = (date) => {
  const operations = [];
  const guests = [
    'Ahmed Hassan', 'Sarah Johnson', 'Michael Brown', 'Maria Garcia', 'David Wilson',
    'Lisa Anderson', 'Omar Al-Rashid', 'Jennifer White', 'Christopher Lee', 'Amanda Davis'
  ];

  const unitNames = ['Standard Room', 'Deluxe Suite', 'Family Suite', 'Executive Suite'];
  const phones = [
    '+20 123 456 7890', '+1 555 123 4567', '+966 50 123 4567', '+971 50 123 4567'
  ];
  const emails = [
    'guest1@email.com', 'guest2@email.com', 'guest3@email.com', 'guest4@email.com'
  ];

  // Generate check-ins (8-12 operations)
  const checkInCount = Math.floor(Math.random() * 5) + 8;
  for (let i = 1; i <= checkInCount; i++) {
    const isOverdue = Math.random() > 0.8;
    const expectedHour = Math.floor(Math.random() * 8) + 14; // 14:00 to 22:00
    const expectedTime = `${expectedHour.toString().padStart(2, '0')}:${Math.floor(Math.random() * 60).toString().padStart(2, '0')}`;

    operations.push({
      id: `checkin-${i}`,
      type: 'checkin',
      reqCode: `book-${1000 + i}`,
      reqClientName: guests[Math.floor(Math.random() * guests.length)],
      phone: phones[Math.floor(Math.random() * phones.length)],
      email: emails[Math.floor(Math.random() * emails.length)],
      unitCode: `${Math.floor(Math.random() * 5) + 1}${Math.floor(Math.random() * 10)}${String.fromCharCode(65 + Math.floor(Math.random() * 3))}`,
      unitName: unitNames[Math.floor(Math.random() * unitNames.length)],
      expectedTime,
      actualTime: Math.random() > 0.6 ? expectedTime : undefined,
      status: Math.random() > 0.7 ? 'confirmed' : Math.random() > 0.5 ? 'pending' : 'early',
      guests: Math.floor(Math.random() * 4) + 1,
      notes: Math.random() > 0.7 ? 'Late arrival, quiet room preferred' : undefined,
      notes: Math.random() > 0.8 ? 'VIP guest, provide upgrade if available' : undefined,
      reqStatus: Math.random() > 0.3 ? 'paid' : Math.random() > 0.5 ? 'partial' : 'pending',
      remainingBalance: Math.random() > 0.5 ? Math.floor(Math.random() * 2000) + 500 : undefined,
      roomStatus: Math.random() > 0.8 ? 'cleaning' : Math.random() > 0.6 ? 'clean' : 'dirty',
      assignedStaff: Math.random() > 0.5 ? 'Ahmed Ali' : undefined,
      priority: Math.random() > 0.9 ? 'urgent' : Math.random() > 0.7 ? 'high' : 'normal'
    });
  }

  // Generate check-outs (6-10 operations)
  const checkOutCount = Math.floor(Math.random() * 5) + 6;
  for (let i = 1; i <= checkOutCount; i++) {
    const expectedHour = Math.floor(Math.random() * 4) + 10; // 10:00 to 14:00
    const expectedTime = `${expectedHour.toString().padStart(2, '0')}:${Math.floor(Math.random() * 60).toString().padStart(2, '0')}`;

    operations.push({
      id: `checkout-${i}`,
      type: 'checkout',
      reqCode: `book-${2000 + i}`,
      reqClientName: guests[Math.floor(Math.random() * guests.length)],
      phone: phones[Math.floor(Math.random() * phones.length)],
      email: emails[Math.floor(Math.random() * emails.length)],
      unitCode: `${Math.floor(Math.random() * 5) + 1}${Math.floor(Math.random() * 10)}${String.fromCharCode(65 + Math.floor(Math.random() * 3))}`,
      unitName: unitNames[Math.floor(Math.random() * unitNames.length)],
      expectedTime,
      actualTime: Math.random() > 0.6 ? expectedTime : undefined,
      status: Math.random() > 0.7 ? 'confirmed' : Math.random() > 0.5 ? 'pending' : 'late',
      guests: Math.floor(Math.random() * 4) + 1,
      notes: Math.random() > 0.8 ? 'Late checkout requested, extra cleaning needed' : undefined,
      notes: Math.random() > 0.9 ? 'Guest extended stay, check room condition' : undefined,
      reqStatus: Math.random() > 0.2 ? 'paid' : 'partial',
      remainingBalance: Math.random() > 0.8 ? Math.floor(Math.random() * 1000) + 200 : undefined,
      roomStatus: Math.random() > 0.6 ? 'dirty' : Math.random() > 0.3 ? 'cleaning' : 'clean',
      assignedStaff: Math.random() > 0.4 ? 'Sara Hassan' : undefined,
      priority: Math.random() > 0.95 ? 'urgent' : 'normal'
    });
  }

  return operations.sort((a, b) => a.expectedTime.localeCompare(b.expectedTime));
};

// Calculate operations statistics
export const calculateOperationsStats = (operations) => {
  const checkIns = operations.filter(op => op.type === 'checkin');
  const checkOuts = operations.filter(op => op.type === 'checkout');

  const now = new Date();
  const currentTime = now.toTimeString().slice(0, 5);

  const overdueCheckIns = checkIns.filter(op =>
    op.operationStatus === 'pending' && op.expectedTime < currentTime
  ).length;

  const overdueCheckOuts = checkOuts.filter(op =>
    op.operationStatus === 'pending' && op.expectedTime < currentTime
  ).length;

  const earlyOperations = operations.filter(op => op.operationStatus === 'early').length;
  const lateOperations = operations.filter(op => op.operationStatus === 'late').length;
  const noShowOperations = operations.filter(op => op.operationStatus === 'noShow').length;

  // Calculate additional revenue from early/late fees
  const additionalRevenue = operations.reduce((sum, op) => {
    if (op.operationStatus === 'late') return sum + 400; // Late checkout fee
    if (op.operationStatus === 'early') return sum + 200; // Early checkin fee
    return sum;
  }, 0);

  const roomsReady = operations.filter(op => op.roomStatus === 'clean').length;
  const roomsCleaning = operations.filter(op => op.roomStatus === 'cleaning').length;

  return {
    totalCheckIns: checkIns.length,
    confirmedCheckIns: checkIns.filter(op => op.operationStatus === 'confirmed').length,
    pendingCheckIns: checkIns.filter(op => op.operationStatus === 'pending').length,
    totalCheckOuts: checkOuts.length,
    confirmedCheckOuts: checkOuts.filter(op => op.operationStatus === 'confirmed').length,
    pendingCheckOuts: checkOuts.filter(op => op.operationStatus === 'pending').length,
    overdueCheckIns,
    overdueCheckOuts,
    earlyOperations,
    lateOperations,
    noShowOperations,
    additionalRevenue,
    averageCheckInTime: 15, // Mock average in minutes
    averageCheckOutTime: 12, // Mock average in minutes
    roomsReady,
    roomsCleaning
  };
};

// Filter operations
export const filterOperations = (operations, filters) => {
  return operations.filter(operation => {
    if (filters.searchTerm) {
      const searchLower = filters.searchTerm.toLowerCase();
      const matchesSearch =
        operation.reqClientName.toLowerCase().includes(searchLower) ||
        operation.unitCode.toLowerCase().includes(searchLower) ||
        operation.phone.includes(searchLower) ||
        operation.email.toLowerCase().includes(searchLower);
      if (!matchesSearch) return false;
    }

    if (filters.type && operation.type !== filters.type) return false;
    if (filters.status && operation.operationStatus !== filters.status) return false;
    if (filters.floor && !operation.unitCode.startsWith(filters.floor)) return false;
    if (filters.roomStatus && operation.roomStatus !== filters.roomStatus) return false;
    if (filters.reqStatus && operation.reqStatus !== filters.reqStatus) return false;
    if (filters.priority && operation.priority !== filters.priority) return false;
    if (filters.assignedStaff && operation.assignedStaff !== filters.assignedStaff) return false;

    if (filters.timeSlot) {
      const hour = parseInt(operation.expectedTime.split(':')[0]);
      switch (filters.timeSlot) {
        case 'morning':
          if (hour < 6 || hour >= 12) return false;
          break;
        case 'afternoon':
          if (hour < 12 || hour >= 17) return false;
          break;
        case 'evening':
          if (hour < 17 || hour >= 21) return false;
          break;
        case 'late':
          if (hour < 21 || hour >= 24) return false;
          break;
      }
    }

    return true;
  });
};

// Calculate early/late checkout fees
export const calculateEarlyLateFee = (
  originalTime,
  requestedTime,
  type
) => {
  const original = new Date(`2024-01-01T${originalTime}:00`);
  const requested = new Date(`2024-01-01T${requestedTime}:00`);
  const hoursDifference = Math.abs((requested.getTime() - original.getTime()) / (1000 * 60 * 60));

  if (type === 'early') {
    // Early check-in fee: 200 EGP base + 50 EGP per hour early
    const fee = 200 + (Math.floor(hoursDifference) * 50);
    return {
      fee,
      description: `Early check-in fee: ${hoursDifference.toFixed(1)} hours early`,
      hoursDifference
    };
  } else {
    // Late check-out fee: 100 EGP per hour after 30-minute grace period
    const gracePeriodHours = 0.5; // 30 minutes
    const chargeableHours = Math.max(0, hoursDifference - gracePeriodHours);
    const fee = Math.ceil(chargeableHours) * 100;
    return {
      fee,
      description: `Late check-out fee: ${chargeableHours.toFixed(1)} hours late (after 30min grace period)`,
      hoursDifference
    };
  }
};

// Get status color configuration
export const getStatusColor = (status) => {
  switch (status) {
    case 'pending':
      return 'bg-yellow-100 text-yellow-800 border-yellow-200';
    case 'confirmed':
      return 'bg-green-100 text-green-800 border-green-200';
    case 'early':
      return 'bg-blue-100 text-blue-800 border-blue-200';
    case 'late':
      return 'bg-orange-100 text-orange-800 border-orange-200';
    case 'noShow':
      return 'bg-red-100 text-red-800 border-red-200';
    case 'onTime':
      return 'bg-blue-200 text-blue-800 border-blue-400';
    case 'cancelled':
      return 'bg-slate-100 text-slate-800 border-slate-200';
    default:
      return 'bg-slate-100 text-slate-800 border-slate-200';
  }
};

// Get time slot for an operation
export const getTimeSlot = (time) => {
  const hour = parseInt(time.split(':')[0]);
  if (hour >= 6 && hour < 12) return 'morning';
  if (hour >= 12 && hour < 17) return 'afternoon';
  if (hour >= 17 && hour < 21) return 'evening';
  return 'late';
};

// Format time for display
export const formatTime = (time) => {
  return time; // Already in HH:MM format
};

// Get priority color
export const getPriorityColor = (priority) => {
  switch (priority) {
    case 'urgent':
      return 'bg-red-100 text-red-800 border-red-200';
    case 'high':
      return 'bg-orange-100 text-orange-800 border-orange-200';
    case 'normal':
      return 'bg-blue-100 text-blue-800 border-blue-200';
    default:
      return 'bg-slate-100 text-slate-800 border-slate-200';
  }
};

// Get room status color
export const getRoomStatusColor = (status) => {
  switch (status) {
    case 'clean':
      return 'bg-green-100 text-green-800 border-green-200';
    case 'dirty':
      return 'bg-red-100 text-red-800 border-red-200';
    case 'cleaning':
      return 'bg-blue-100 text-blue-800 border-blue-200';
    case 'maintenance':
      return 'bg-orange-100 text-orange-800 border-orange-200';
    default:
      return 'bg-slate-100 text-slate-800 border-slate-200';
  }
};

// Get payment status color
export const getPaymentStatusColor = (status) => {
  switch (status) {
    case 'paid':
      return 'bg-green-100 text-green-800 border-green-200';
    case 'partial':
      return 'bg-yellow-100 text-yellow-800 border-yellow-200';
    case 'pending':
      return 'bg-red-100 text-red-800 border-red-200';
    default:
      return 'bg-slate-100 text-slate-800 border-slate-200';
  }
};